
import './CompteClient.scss';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { FormControlLabel,Radio,RadioGroup, ThemeProvider } from '@mui/material';
import {Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
//import Checkbox from '@mui/material/Checkbox';
import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {useLocation, useParams } from 'react-router-dom';

import { buttonStyles, buttonStylesBlue } from '../../../Components/docsAdministrative/JsObjectStyles';
import { IconTextField, SelectComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import SearchCity from '../../../Components/shared/SearchCity';
import { conditionPaiement, delaiPaiementList} from '../../../data/Interfaces';
//import {   laguesFacturation } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { CompareTwoString } from '../../../Utils/utils';
import { isValidEmail } from '../../../Utils/validationUtils';

function DonnesFacturationParent() {
    const axiosPrivate = useAxiosPrivate();
    const [dataClient, setdataClient] = useState({});
    let param = useParams();
    const [adress, setAdress] = useState('');
    const location = useLocation();
    // the new adress should be {} not string const [adress, setAdress] = useState({});
    const [notSameSiegeAdress,setNotSameSiegeAdress]=useState('');
    const [email, setEmail] = useState('');
    const [tele, setTele] = useState('');
    const {device}=useWindowSize();
    const [numTva, setNumTva] = useState('');
    const [tauxTva, setTauxTva] = useState('');
    const [parVirement, setParVirement] = useState(null);
    const [delaiPaiement, setDelaiPaiement] = useState(null);
    const [localisation,setLocalisation] = useState('');
    const [codePostal,setCodePostal] = useState('');
    const { inputSize } = useWindowSize();
    const [nomBangue, setNomBangue] = useState('');
    const [IBAN, setIBAN] = useState('');
    const [BIC, setBIC] = useState('');
    const role = useRole();
    const { setBackdropOpen } = useUtilities();
    const [checkUpdateValue, setCheckUpdateValue] = useState();
    const [authorizedModifyInfo,setAuthorizedModifyInfo]= useState(false);
    const { i18n } = useTranslation();

    useEffect(() => {
        getClientbyId();
    }, [role]);

    useEffect(() => {
        if (Object.keys(dataClient).length !== 0 )
            setInitialValue(dataClient);
    }, [dataClient]);

    useEffect(() => {
        if (notSameSiegeAdress=='same'){
            setAdress(dataClient?.profileEntreprise?.address);
            setCodePostal(dataClient?.profileEntreprise?.codePostal);
            setLocalisation(dataClient?.profileEntreprise?.localisation);
        }
    }, [notSameSiegeAdress,dataClient]);

    const setInitialValue = (data) => {
        const facturation = data?.donneeFacturation;
        const profile = data?.profileEntreprise;

        if (facturation?.adresseFacturation && facturation?.adresseFacturation === profile?.address &&
            facturation?.codePostal === profile?.codePostal && facturation?.localisation === profile?.localisation) {
            setNotSameSiegeAdress('same');
        } else if (facturation?.adresseFacturation) {
            setNotSameSiegeAdress('autre');
            setAdress(facturation.adresseFacturation);
        } else {
            setNotSameSiegeAdress('same');
            setAdress(profile.address);
        }

        setEmail(facturation?.emailFacturation);
        setParVirement(facturation?.typeReglement);
        setTauxTva(facturation?.tauxTva);
        setTele(facturation?.teleFacturation);
        setDelaiPaiement(facturation?.delaiPaiement);
        setNomBangue(facturation?.nomBanque);
        setBIC(facturation?.BICSWIFT);
        setIBAN(facturation?.IBAN);
        setCheckUpdateValue(true);
        setBackdropOpen(false);
    };

    const getClientbyId = async () => {
        if (role == 'admin') {
            let endpoint = location.pathname.includes('gestionEsn') ? '/users/getEsnById/':'/users/getClientById/';
            try {
                setBackdropOpen(true);
                const response = await axiosPrivate.get(endpoint + (param.ClientId ?? param.EsnId));
                setdataClient(response?.data);
                setNumTva(response?.data?.profileEntreprise?.noTVA);
                console.log('response.data', response?.data);
            } catch (error) {
                console.log(error);
                setBackdropOpen(false);
            }
        }
        if (role == 'client') {
            try {
                setBackdropOpen(true);
                const response = await axiosPrivate.get('/client/getMyInfos');
                if(response?.data?.collaborator?.roles['Admin']==1 || response?.data?.collaborator?.roles['littleAdmin']==1){
                    setAuthorizedModifyInfo(true);
                }
                setdataClient(response?.data?.collaborator?.companyDataId);
                setNumTva(response?.data?.collaborator?.companyDataId?.profileEntreprise?.noTVA);
                console.log('response?.data', response?.data);
            } catch (error) {
                console.log(error);
                setBackdropOpen(false);
            }
        }
        if (role == 'esn') {
            try {
                setBackdropOpen(true);
                const response = await axiosPrivate.get('/esn/getMyInfos');
                if(response?.data?.collaboratorEsn?.roles['Admin']==1 || response?.data?.collaboratorEsn?.roles['littleAdmin']==1){
                    setAuthorizedModifyInfo(true);
                }
                setdataClient(response?.data?.collaboratorEsn?.esnId);
                setNumTva(response?.data?.collaboratorEsn?.esnId?.profileEntreprise?.noTVA);
                console.log('response?.data', response?.data);
            } catch (error) {
                console.log(error);
                setBackdropOpen(false);
            }
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };

    const enregistrerDonneesBackend = async () => {
        if (role == 'client') {
            //pour V2
            //let checkemail = '';
            //let checkPhysique = '';
            //if (checkedParEmail)
            //    checkemail = 'email';
            //if (checkedAdressePhysique)
            //    checkPhysique = 'physique';
            try {
                setBackdropOpen(true);
                const response1 = await axiosPrivate.post('/client/updateMyDonneeFacturation',
                    {
                        donneeFacturation: {
                            adresseFacturation: adress,
                            emailFacturation: email,
                            teleFacturation: tele,
                            noTva: numTva,
                            //langueFacture: langue,
                            //autreDestinataires: [destinataire],
                            //modeEnvoi: [checkemail, checkPhysique],
                            nomBanque: nomBangue,
                            IBAN: IBAN,
                            BICSWIFT: BIC,
                            localisation,
                            codePostal,
                        }
                    },
                );
                setBackdropOpen(false);
                console.log(response1);
            } catch (error) {
                console.log(error.response?.status);
                setBackdropOpen(false);
            }
        }
        if (role == 'admin') {
            try {
                setBackdropOpen(true);
                let endpoint = location.pathname.includes('gestionEsn') ? '/esn/updateDonneeFacturation/':'/client/updateDonneeFacturation/';
                const response1 = await axiosPrivate.post(endpoint,
                    {
                        ...(location.pathname.includes('gestionEsn')
                            ? { esnId: param.EsnId }
                            : { clientId: param.ClientId }),
                        donneeFacturation: {
                            tauxTva: tauxTva,
                            typeReglement: parVirement,
                            delaiPaiement: delaiPaiement,
                        }
                    },
                );
                console.log(response1);
                setBackdropOpen(false);
            } catch (error) {
                console.log(error.response?.status);
                setBackdropOpen(false);
            }
        }
        if (role == 'esn') {
            try {
                setBackdropOpen(true);
                const response1 = await axiosPrivate.post('/esn/updateMyDonneeFacturation',
                    {
                        donneeFacturation: {
                            adresseFacturation: adress,
                            emailFacturation: email,
                            teleFacturation: tele,
                            noTva: numTva,
                            //langueFacture: langue,
                            //autreDestinataires: [destinataire],
                            //modeEnvoi: [checkemail, checkPhysique],
                            nomBanque: nomBangue,
                            IBAN: IBAN,
                            BICSWIFT: BIC,
                            localisation,
                            codePostal,
                        }
                    },
                );
                console.log(response1);
                setBackdropOpen(false);
            } catch (error) {
                console.log(error.response?.status);
                setBackdropOpen(false);
            }
        }
    };

    return (
        <>
            <div className='frame0DonneeFacturation'>
                <h4 className='titlesociete'>{i18n.t('Données Facturation')}</h4>

                <div className='frame3DonneeFacturation'>
                    <h6 className='frame4DonneeFacturation'>{i18n.t('Informations de facturation')}</h6>
                    <div className='frame5DonneeFacturation'>
                        <div className='frame6DonneeFacturation'>
                            <div className='frame10DonneeFacturation'>
                                <RadioGroup
                                    value={notSameSiegeAdress}
                                    style={{ display: 'flex', flexDirection:device=='desktop'?'row':'column', gap: '8px', alignSelf: 'stretch', width: '100%' }}
                                    onChange={(e) => {
                                        setNotSameSiegeAdress(e.target.value);
                                        setCheckUpdateValue(false);
                                    }}
                                >
                                    <div
                                        style={{
                                            boxSizing: 'border-box',
                                            alignItems: 'center',
                                            //height: '40px',
                                            padding: inputSize == 'small' ? '0px  8px' : '8px 16px',
                                            height: inputSize == 'small' ? '40px' : '56px',
                                            gap: '4px',
                                            width: device=='desktop'?'49%':'100%',
                                            background: '#FFFFFF',
                                            border: '1px solid #9D9E9F',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <ThemeProvider theme={FieldComponentFont}>
                                            <FormControlLabel
                                                value="same"
                                                control={<Radio />}
                                                disabled={authorizedModifyInfo == true ? false : true}
                                                label={i18n.t('Adresse du siège')}
                                            />
                                        </ThemeProvider>

                                    </div>

                                    <div
                                        style={{
                                            boxSizing: 'border-box',
                                            padding: inputSize == 'small' ? '0px  8px' : '8px 16px',
                                            gap: '4px',
                                            height: inputSize == 'small' ? '40px' : '56px',
                                            whiteSpace: 'nowrap',
                                            width: device=='desktop'?'49%':'100%',
                                            background: '#FFFFFF',
                                            border: '1px solid #9D9E9F',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <ThemeProvider theme={FieldComponentFont}>
                                            <FormControlLabel
                                                value="autre"
                                                control={<Radio />}
                                                disabled={authorizedModifyInfo == true ? false : true}
                                                label={i18n.t('Autre adresse')}
                                            />
                                        </ThemeProvider>
                                    </div>
                                </RadioGroup>
                            </div>
                            {notSameSiegeAdress=='autre' &&
                                <>
                                    <div className='frame7DonneeFacturation'>
                                        <p className='frame8DonneeFacturation'>{i18n.t('Adresse de facturation')}</p>
                                        <TextFieldComponent
                                            id="outlined-name"
                                            //label="Adresse"
                                            value={adress}
                                            onChange={(event) => {
                                                if (!CompareTwoString(event.target.value, dataClient?.donneeFacturation?.adresseFacturation)) {
                                                    setCheckUpdateValue(false);
                                                }
                                                setAdress(event.target.value);
                                            }}
                                            disabled={authorizedModifyInfo == true ? false : true}
                                            //margin="normal"
                                            style={{ width: '100%', backgroundColor: 'white', borderRadius: '8px' }}
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                            }}
                                        />
                                    </div>
                                    <div className="SuiteAdresse">
                                        <SearchCity
                                            name='localisation'
                                            city={localisation}
                                            label={i18n.t('Ville')}
                                            setCity={setLocalisation}
                                            width={device=='desktop'?'50%':'100%'}
                                            //role={role=='admin' ? 'visibleOnly' : ''}
                                            role={authorizedModifyInfo == false ? 'visibleOnly' : ''}
                                            check={setCheckUpdateValue}
                                        />
                                        <TextFieldComponent
                                            id="outlined-uncontrolled"
                                            name='codePostal'
                                            label={i18n.t('Code Postal *')}
                                            //disabled={role=='admin' ? true : false}
                                            type='number'
                                            onKeyDown={handleKeyDown}
                                            InputProps={{
                                                inputProps: { min: 0,}
                                            }}
                                            disabled={authorizedModifyInfo == true ? false : true}
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px'},
                                            }}
                                            style={{width:device=='desktop'?'50%':'100%', background: 'white',borderRadius: '8px'}}
                                            value={codePostal}

                                            onChange={(e) => {
                                                if(!CompareTwoString(e.target.value,dataClient?.profileEntreprise?.codePostal)){
                                                    setCheckUpdateValue(false);
                                                }
                                                setCodePostal(e.target.value);
                                            }}
                                        />
                                    </div>
                                </>
                            }
                            <div className='frame10DonneeFacturation'>
                                <div className='frame11DonneeFacturation'>
                                    <TextFieldComponent
                                        id="outlined-name"
                                        label={i18n.t('E-mail de facturation')}
                                        value={email}
                                        onChange={(event) => {
                                            if (!CompareTwoString(event.target.value, dataClient?.donneeFacturation?.emailFacturation)) {
                                                setCheckUpdateValue(false);
                                            }
                                            setEmail(event.target.value);
                                        }}
                                        //disabled={role == 'admin' ? true : false}
                                        disabled={authorizedModifyInfo == true ? false : true}
                                        style={{ width: '100%', backgroundColor: 'white', borderRadius: '8px' }}
                                        sx={{
                                            '& > :not(style)': { borderRadius: '8px' },
                                        }}
                                        // ! those error/helpertext doesn t work since wo had another ones at the parent component
                                        error={email && !isValidEmail(email)}
                                        helperText={(email && !isValidEmail(email)) ? i18n.t('E-mail non valide') : ''}
                                    />
                                </div>
                                <div className='frame11DonneeFacturation'>
                                    <TextFieldComponent
                                        id="outlined-name"
                                        label={i18n.t('Téléphone du contact')}
                                        value={tele}
                                        type='text'
                                        onChange={(event) => {
                                            if (!CompareTwoString(event.target.value, dataClient?.donneeFacturation?.teleFacturation)) {
                                                setCheckUpdateValue(false);
                                            }
                                            setTele(event.target.value);
                                        }}
                                        //disabled={role == 'admin' ? true : false}
                                        disabled={authorizedModifyInfo == true ? false : true}
                                        style={{ width: '100%', backgroundColor: 'white', borderRadius: '8px' }}
                                        sx={{
                                            '& > :not(style)': { borderRadius: '8px' },
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='frame10DonneeFacturation'>
                                <div className='frame11DonneeFacturation'>
                                    <TextFieldComponent
                                        id="outlined-name"
                                        label={i18n.t('Numéro du TVA')}
                                        value={numTva}
                                        //type='number'
                                        //onChange={(event) => {
                                        //    if (!CompareTwoString(event.target.value, dataClient?.donneeFacturation?.noTva)) {
                                        //        setCheckUpdateValue(false);
                                        //    }
                                        //    setNumTva(event.target.value);
                                        //}}
                                        //disabled={true}
                                        disabled={authorizedModifyInfo == true ? false : true}
                                        style={{ width: '100%', backgroundColor: 'white', borderRadius: '8px' }}
                                        sx={{
                                            '& > :not(style)': { borderRadius: '8px' },
                                        }}
                                    />
                                </div>
                                <div className='frame11DonneeFacturation'>
                                    <IconTextField
                                        id="outlined-name"
                                        label={i18n.t('Taux de la TVA')}
                                        value={tauxTva}
                                        iconStart={'%'}
                                        InputProps={{
                                            inputProps: { min: 0, max: 100 },
                                            //startAdornment: (<div className='iconStyleStartAdornment'><InputAdornment position="start">
                                            //    %
                                            //</InputAdornment> </div>),

                                        }}
                                        type='number'
                                        onKeyDown={handleKeyDown}
                                        onChange={(event) => {
                                            if (!CompareTwoString(event.target.value, dataClient?.donneeFacturation?.tauxTva)) {
                                                setCheckUpdateValue(false);
                                            }
                                            setTauxTva(event.target.value);
                                        }}
                                        disabled={(role == 'client' || role=='esn') ? true : false}
                                        style={{ width: '100%', backgroundColor: 'white', borderRadius: '8px' }}
                                        sx={{
                                            '& > :not(style)': { borderRadius: '8px' },
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <h6 className='frame4DonneeFacturation'>{i18n.t('Conditions de paiement')}</h6>
                        <div className='frame10DonneeFacturation'>
                            <div
                                className='frame7DonneeFacturation'
                                style={{width:device=='desktop'?'50%':'100%'}}
                            >
                                <p className='frame8DonneeFacturation'>{i18n.t('Type de règlement')}</p>
                                {/*//doit etre un select (avec par virement souleent)*/}
                                <SelectComponent
                                    val={parVirement}
                                    //label={'Type de règlement'}
                                    setVal={(event) => {
                                        setParVirement(event.target.value);
                                    }}
                                    disabled={(role == 'client'|| role=='esn') ? true : false}
                                    listVal={conditionPaiement}
                                />
                            </div>
                            <div
                                className='frame7DonneeFacturation'
                                style={{width:device=='desktop'?'50%':'100%'}}
                            >
                                <div style={{display:'flex',flexDirection:'row',gap:'4px'}}>
                                    <p className='frame8DonneeFacturation'>{i18n.t('Délai de paiement')}</p>
                                    <Tooltip title={i18n.t('Délai de paiement est à la date de facture')}>
                                        <InfoOutlinedIcon />
                                    </Tooltip>
                                </div>
                                <SelectComponent
                                    //label={'Délai de paiement'}
                                    val={delaiPaiement}
                                    disabled={(role == 'client'|| role=='esn') ? true : false}
                                    setVal={(event) => {
                                        if (!CompareTwoString(event?.target?.value, dataClient?.donneeFacturation?.delaiPaiement)) {
                                            setCheckUpdateValue(false);
                                        }
                                        setDelaiPaiement(event?.target?.value);
                                    }}
                                    listVal={delaiPaiementList}
                                />
                            </div>
                        </div>

                        {/*masquer pour la 2*/}
                        {/*<div className='frame16DonneeFacturation'>
                            <h6 className='frame4DonneeFacturation'>Préférences</h6>
                            <div className='frame19DonneeFacturation'>
                                <div className='frame20DonneeFacturation'>
                                    <p className='frame8DonneeFacturation'>Langue des factures</p>
                                    <SelectComponent
                                        val={langue}
                                        //disabled={role == 'admin' ? true : false}
                                        disabled={authorizedModifyInfo == true ? false : true}
                                        setVal={(event) => {
                                            if (!CompareTwoString(event.target.value, dataClient?.donneeFacturation?.langueFacture)) {
                                                setCheckUpdateValue(false);
                                            }
                                            setLangue(event.target.value);
                                        }}
                                        listVal={laguesFacturation}
                                    />
                                </div>
                                <div className='frame25DonneeFacturation'>
                                    <p className='frame8DonneeFacturation'>Mode d&apos;envoi</p>
                                    <div className='frame27DonneeFacturation'>
                                        <div className='frame28DonneeFacturation'>
                                            <div className='frame29DonneeFacturation'>
                                                <Checkbox
                                                    {...labelcheckbox}
                                                    checked={checkedAdressePhysique}
                                                    //disabled={role == 'admin' ? true : false}
                                                    disabled={authorizedModifyInfo == true ? false : true}
                                                    onChange={(event) => {
                                                        let temp = dataClient?.donneeFacturation?.modeEnvoi.includes('physique');
                                                        if (!CompareTwoString(event.target.checked, temp ? true : false)) {
                                                            setCheckUpdateValue(false);
                                                        }
                                                        setCheckedAdressePhysique(event.target.checked);
                                                    }}
                                                />
                                            </div>
                                            <p className='frame30DonneeFacturation'>Adresse physique</p>
                                        </div>
                                        <div className='frame28DonneeFacturation'>
                                            <div className='frame29DonneeFacturation'>
                                                <Checkbox
                                                    {...labelcheckbox}
                                                    disabled
                                                    checked={checkedParEmail}
                                                    onChange={(event) => {
                                                        setCheckedParEmail(event.target.checked);
                                                    }}
                                                    style={{ borderRadius: '5px' }}
                                                />
                                            </div>
                                            <p className='frame30DonneeFacturation'>Par E-mail</p>
                                        </div>
                                    </div>
                                    <div
                                        className='frame20DonneeFacturation'
                                    //key={i}
                                    >
                                        <p className='frame8DonneeFacturation'>Ajouter un destinataire </p>
                                        <TextFieldComponent
                                            id="outlined-name"
                                            //disabled={role == 'admin' ? true : false}
                                            disabled={authorizedModifyInfo == true ? false : true}
                                            value={destinataire}
                                            onChange={(event) => {
                                                if (!CompareTwoString(event.target.value, dataClient?.donneeFacturation?.autreDestinataires[0])) {
                                                    setCheckUpdateValue(false);
                                                }
                                                setDestinataire(event.target.value);
                                            }}
                                            //value={x.firstName}
                                            //onChange={e => handleInputChange(e, i)}
                                            style={{ width: '100%', backgroundColor: 'white', borderRadius: '8px' }}
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                                //'& label': {color: 'rgba(0, 0, 0, 0.39)'}

                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>*/}
                        {/* //* OLD, we removed it for logical business purposes , keep it here*/}
                        {role=='esn' &&
                            <div className='frame32DonneeFacturation'>
                                <h6 className='frame4DonneeFacturation'>
                                        Coordonnées bancaires de l&apos;entreprise
                                </h6>
                                <div className='frame34DonneeFacturation'>
                                    <div className='frame36DonneeFacturation'>
                                        <p className='frame8DonneeFacturation'>Nom de banque</p>
                                        <TextFieldComponent
                                            id="outlined-name"
                                            disabled={role=='admin' ? true : false}
                                            value={nomBangue}
                                            onChange={(event)=>{
                                                if (!CompareTwoString(event.target.value, dataClient?.donneeFacturation?.nomBanque)) {
                                                    setCheckUpdateValue(false);
                                                }
                                                setNomBangue(event.target.value);
                                            }}
                                            style={{width: '100%' ,backgroundColor:'white',borderRadius:'8px'}}
                                            sx={{
                                                '& > :not(style)': {borderRadius:'8px'},
                                            }}
                                            //InputProps={{endAdornment: <DeleteButton />}}
                                        />
                                    </div>
                                    <div className='frame36DonneeFacturation'>
                                        <TextFieldComponent
                                            label='IBAN'
                                            value={IBAN}
                                            onChange={(event)=>{
                                                if (!CompareTwoString(event.target.value, dataClient?.donneeFacturation?.IBAN)) {
                                                    setCheckUpdateValue(false);
                                                }
                                                setIBAN(event.target.value);
                                            }}
                                            disabled={role=='admin' ? true : false}
                                            style={{width: '100%',backgroundColor:'white',borderRadius:'8px'}}
                                            sx={{
                                                '& > :not(style)': {borderRadius:'8px' },

                                            }}
                                        />
                                        <TextFieldComponent
                                            id="outlined-name"
                                            label="BIC/SWIFT"
                                            value={BIC}
                                            onChange={(event)=>{
                                                if (!CompareTwoString(event.target.value, dataClient?.donneeFacturation?.BICSWIFT)) {
                                                    setCheckUpdateValue(false);
                                                }
                                                setBIC(event.target.value);
                                            }}
                                            disabled={role=='admin' ? true : false}
                                            style={{width: '100%',backgroundColor:'white',borderRadius:'8px'}}
                                            sx={{
                                                '& > :not(style)': {borderRadius:'8px' },
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        }

                        <div style={{ display: 'flex',gap:device=='desktop'?'0px':'16px', flexDirection: device=='desktop'?'row':'column', justifyContent: 'space-between', alignSelf: 'stretch' }}>
                            <Button
                                variant="text"
                                style={{...buttonStyles(),...{order:device=='desktop'?'0':'1',width:device=='desktop'?'auto':'100%'}}}
                                onClick={() => { setInitialValue(dataClient); }}
                            >
                                {i18n.t('Annuler')}
                            </Button>
                            <Button
                                variant="contained"
                                type="submit"
                                style={{...buttonStylesBlue(checkUpdateValue || (email && !isValidEmail(email))),...{order:device=='desktop'?'1':'0',width:device=='desktop'?'auto':'100%'}}}
                                disabled={checkUpdateValue || (email && !isValidEmail(email))}
                                onClick={() => {
                                    enregistrerDonneesBackend();
                                    setCheckUpdateValue(true);
                                }}
                                startIcon={<SaveOutlinedIcon />}
                            >
                                {i18n.t('Sauvegarder')}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default DonnesFacturationParent;
